import { render, staticRenderFns } from "./DashboardDropdown.vue?vue&type=template&id=0d9e0520&scoped=true&"
import script from "./DashboardDropdown.vue?vue&type=script&lang=js&"
export * from "./DashboardDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDropdown.vue?vue&type=style&index=0&id=0d9e0520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9e0520",
  null
  
)

export default component.exports